import { render, staticRenderFns } from "./UserDataCard.vue?vue&type=template&id=3b3d896e&scoped=true"
import script from "./UserDataCard.vue?vue&type=script&lang=js"
export * from "./UserDataCard.vue?vue&type=script&lang=js"
import style0 from "./UserDataCard.vue?vue&type=style&index=0&id=3b3d896e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d896e",
  null
  
)

export default component.exports